import {
	LoadingProductCardSkeletonItem,
	LoadingSkeleton,
} from 'components/LoadingSkeleton';
import ProductCard from 'components/ProductCard';
import type { GTMItemListId, GTMItemListName } from 'hooks/gtm';
import type { BasketRowResponse } from 'models/api';
import { range } from 'utils/helpers';

interface Props {
	gtmItemListId: GTMItemListId;
	gtmItemListName: GTMItemListName;
	isLoading: boolean;
	rows: BasketRowResponse[] | undefined;
}

export default function CampaignBuyAnyProducts({
	gtmItemListId,
	gtmItemListName,
	isLoading,
	rows,
}: Props) {
	if (isLoading) {
		return (
			<LoadingSkeleton className="space-y-8">
				{range(2).map((i) => (
					<LoadingProductCardSkeletonItem
						key={i}
						orientation="horizontal"
						showAddToCartButton
					/>
				))}
			</LoadingSkeleton>
		);
	}

	if (!rows) {
		return null;
	}

	return (
		<ul className="space-y-8">
			{rows.map((row, i) => (
				<li key={row.variantId}>
					<ProductCard
						orientation="horizontal"
						product={row}
						showAddToCartButton
						showAddToWishlistButton
						gtmItemListId={gtmItemListId}
						gtmItemListName={gtmItemListName}
						productListIndex={i}
						showPriceSectionProductTag={false}
						openAddedProductPopover={false}
					/>
				</li>
			))}
		</ul>
	);
}
CampaignBuyAnyProducts.displayName = 'CampaignBuyAnyProducts';
